<template>
    <!--Login Layout -->
    <div id="app" v-if="$route.path === '/login'" class="bgImg">
        <router-view/>
        <vue-snotify></vue-snotify>
        <vue-progress-bar></vue-progress-bar>
    </div>
    <!-- Dashboard  Layout -->
    <div id="app" v-else class="container-fluid no-gutters">
        <router-view/>
        <vue-snotify></vue-snotify>
        <vue-progress-bar></vue-progress-bar>
    </div>
</template>

<script>
import NavBar from './views/includes/NavBar';

export default {
  components: { NavBar },
};
</script>
